import * as Sentry from '@sentry/react';

export function initSentry() {
  if (!import.meta.env.PROD) return; // only prod

  Sentry.init({
    dsn: "https://e20a728b7ab88de7909586366646fb6b@o4510454926082048.ingest.us.sentry.io/4510454927392769",
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1, // 10% of transactions for perf
    beforeSend(event) {
      return event; // place to scrub sensitive data
    },
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Network request failed',
      /Loading chunk .* failed/,
    ],
  });
}

export function captureAskCircleError(
  error: Error,
  context: {
    userId?: string;
    conversationId?: string;
    action?: string;
  }
) {
  if (!import.meta.env.PROD) {
    console.error('AskCircle error (dev):', error, context);
    return;
  }

  Sentry.captureException(error, {
    tags: { feature: 'askcircle' },
    extra: context,
  });
}
